var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.21875C3.25481 0.21875 0.21875 3.25481 0.21875 7C0.21875 10.7452 3.25481 13.7812 7 13.7812C10.7452 13.7812 13.7812 10.7452 13.7812 7C13.7812 3.25481 10.7452 0.21875 7 0.21875ZM7 1.53125C10.0224 1.53125 12.4688 3.97718 12.4688 7C12.4688 10.0224 10.0228 12.4688 7 12.4688C3.97764 12.4688 1.53125 10.0228 1.53125 7C1.53125 3.97764 3.97718 1.53125 7 1.53125ZM10.8337 5.09324L10.2175 4.47204C10.0899 4.34339 9.88211 4.34254 9.75346 4.47018L5.88837 8.30421L4.25343 6.65602C4.12582 6.52736 3.91806 6.52652 3.78941 6.65413L3.16818 7.27035C3.03953 7.39796 3.03868 7.60572 3.16632 7.7344L5.64862 10.2368C5.77623 10.3654 5.98399 10.3663 6.11264 10.2386L10.8319 5.55729C10.9605 5.42965 10.9613 5.22189 10.8337 5.09324Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.2b90eca5.svg";
export { ForwardRef as ReactComponent };